let submitButton = document.querySelector('.full-image-banner__search input[type="submit"]'),
    buttonTrigger = document.querySelector('.full-image-banner__search .button-trigger');

if (submitButton && buttonTrigger) {
    buttonTrigger.addEventListener('click', function(event) {
        submitButton.click();
    });
}
